
import Axios from 'axios'


function fahrenheitToCelsiusRounded (tempF) {
    let tempC = (5/9) * (tempF - 32);
    return Math.round(tempC);
}

function fixIconString(icon){
    return  icon.toUpperCase().replaceAll('-', '_');
}

async function getWeatherInfo(lat, lon) {

    var urlProxy = "https://cors-anywhere.herokuapp.com/";
    var urlApi = "https://api.darksky.net/forecast/557ecd4b8c8bbba02f4a50afe884934b/";

    // call the darksky.net api
    var url = urlProxy + urlApi + lat + "," + lon;

    try{
        let resp = await Axios.get(url);

        return {
            temperature : fahrenheitToCelsiusRounded(resp.data.currently.temperature),
            icon : fixIconString(resp.data.currently.icon),
            summary : resp.data.currently.summary,
        }
    }
    catch(err){
        return { errorMsg : err.message};
    }
}

export default {getWeatherInfo}